export default __webpack_public_path__ + "static/media/video18.1b784d31.webp";